import { Component, Input, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { DashboardService } from 'src/app/dashboard/dashboard.service';
import SlideoutSettingsManager from 'src/shared/models/slideout-settings-manager';
import { DateRangeSelectorService } from '../date-range-selector/date-range-selector.service';
import { CvConfigurationService } from '../services/cv-configuration.service';
import { CVLocalizationService } from '../services/cv-localization.service';

@Component({
    selector: 'cv-time-range-selector',
    templateUrl: './time-range-selector.component.html',
    styleUrls: ['./time-range-selector.component.scss']
})
export class TimeRangeSelectorComponent implements OnInit {
    @Input() settingsManager: SlideoutSettingsManager;
    @Input() stateKey: string;
    @Input() displayMode: 'slider' | 'picker' = 'slider';
    @Input() hideDisabled = false;

    cxOneOptions = [
        { order: 1, id: null, name: 'View all' },
        { order: 2, id: false, name: 'Include' },
        { order: 3, id: true, name: 'Exclude' },
    ];
    cxOneMap = { null: 0, false: 1, true: 2 };
    get disableOrInvertCxOne() {
        const index = this.cxOneMap[this.settingsManager.disableOrInvertTimeSelector?.toString() ?? 'null'];
        return this.cxOneOptions[index];
    }
    set disableOrInvertCxOne(v: {order: number; id: boolean; name: string}) {
        this.settingsManager.disableOrInvertTimeSelector = v.id;
    }

    saveTimeSettingsDebouncer = new Subject<void>();
    includeExcludeHelpText = "This option only applies if the date range is less than 31 days.";

    constructor(
        public config: CvConfigurationService,
        private dateRangeSelectorService: DateRangeSelectorService,
        private localizationService: CVLocalizationService,
        public dashboardService: DashboardService,
    ) { }

    async ngOnInit() {
        await this.localizationService.GetSection('Module');

        //Try to load the includeExcludeHelpText, but if that fails, default back to itself (which is defaulted above)
        this.includeExcludeHelpText = this.localizationService.getCachedText(
            'Module',
            'Include_Exclude_Time_Help',
            this.includeExcludeHelpText
        );

        this.cxOneOptions[0].name = this.localizationService.getCachedText('Module', 'View_All', 'View all');
        this.cxOneOptions[1].name = this.localizationService.getCachedText('Module', 'Include', 'Include');
        this.cxOneOptions[2].name = this.localizationService.getCachedText('Module', 'Exclude', 'Exclude');

        this.saveTimeSettingsDebouncer.pipe(debounceTime(400)).subscribe(() => this.saveTimeSettings());
    }


    toggleHours() {
        if (!this.settingsManager.isTimeSelectorEnabled) { // Revert changes if the checkbox was unchecked
            this.settingsManager.invertTimeSelector = false;
            this.dateRangeSelectorService.saveTimeSettings(this.stateKey, this.settingsManager.isTimeSelectorEnabled, 0, 1440, false);
        } else {
            this.saveTimeSettingsDebouncer.next();
        }
    }

    toggleHoursForPicker() {
        if (!this.settingsManager.isTimeSelectorEnabled) {
            this.dateRangeSelectorService.saveTimeSettings(this.stateKey, this.settingsManager.isTimeSelectorEnabled, 0, 1440, false);
        } else {
            this.saveTimeSettingsDebouncer.next();
        }
    }

    saveTimeSettings() {
        this.dateRangeSelectorService.saveTimeSettings(
            this.stateKey,
            this.settingsManager.isTimeSelectorEnabled,
            this.settingsManager.minTime * 60,
            this.settingsManager.maxTime * 60,
            this.settingsManager.invertTimeSelector,
        );
    }

    saveInvertTimeSelector() {
        this.dateRangeSelectorService.saveInvertTimeSelectorSetting(this.stateKey, this.settingsManager.invertTimeSelector);
    }
}
